import type { reviewPrompt as enReviewPrompt } from "../en/reviewPrompt";

export const reviewPrompt: typeof enReviewPrompt = {
  negative: {
    heading: "Grazie — cosa possiamo migliorare in {{appName}}?",
    body: "Raccontaci cosa non funziona e ce ne occuperemo — il tuo feedback arriva direttamente al team.",
    contactSupport: "Contatta l'assistenza",
    orLeaveReview: "Oppure lascia una recensione",
  },
  positiveFallback: {
    heading: "Ti stai trovando bene con {{appName}}?",
    body:
      "Se hai un momento, puoi condividere la tua esperienza sullo Shopify App Store. Aiuta altri commercianti e aiuta noi a migliorare.",
    writeReview: "Scrivi una recensione",
  },
  ask: {
    heading: "Come sta andando {{appName}} per te?",
    body: "Ci piacerebbe sapere come sta andando.",
    goingWell: "Sta andando bene",
    couldBeBetter: "Potrebbe andare meglio",
  },
};
